import React from 'react';

import { useSwarm } from '@lbs/swarm-client';

import './style.scss';
import { getGameDataRequest, getNextRacingsList } from '@racings/api/requests';
import { GetArrayGame } from '@common/helpers/util/swarmTreeDestructuring';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { useTranslation } from '@common/hooks/translation';
import { RacingCard } from './racingCard';
import { SportTypesIds, SportTypesUrlIds } from '@racings/constants/enums/sportTypes';
import { useParams } from 'react-router-dom';
import moment from 'moment';

export const ComingSoonRacings = asyncWrapper(() => {
  const {
    sportType, compId,
  } = useParams();
  const activeSportId = SportTypesUrlIds[sportType] || SportTypesIds.HORSE;

  const racingsList = GetArrayGame(useSwarm(getNextRacingsList(activeSportId))?.game, 'start_ts');

  const listIds = racingsList.slice(0, 15).map((game) => game.id);

  const data = GetArrayGame(useSwarm(getGameDataRequest(listIds))?.game, 'start_ts');
  const t = useTranslation();

  if (!data?.length) return null;

  return (
    <div className="upcoming-racing">
      <div className="racing-header">{t('Upcoming races')}</div>
      <div className="racin-card-wrapper">
        {data
          .filter((game) =>  (game.start_ts >= moment().unix()))
          .map((game) => (
            <RacingCard key={game.id} game={game} />
          ))}
      </div>
    </div>
  );
});
